import { Box, Typography, Button } from '@mui/material'
import { ArrowBack } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { UserInfoSection } from '../components/settings/UserInfoSection'

export default function ProfileEditPage() {
  const navigate = useNavigate()

  return (
    <Box>
      {/* Header with Back Button */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Button
          variant="outlined"
          startIcon={<ArrowBack />}
          onClick={() => navigate('/profile')}
        >
          Back to Profile
        </Button>
        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
          Edit Profile
        </Typography>
      </Box>

      {/* User Info Section */}
      <UserInfoSection />
    </Box>
  )
}
